export function checkNever(data: never): never {
  throw new Error(`Check never reached with '${data}'.`);
}
